import { useState } from 'react';
import { isEmpty, uniqueId } from 'lodash';
import { createUniqueClassName } from '@zapier/design-system/dist/utils/createUniqueClassName';
import { Tooltip, } from '@zapier/design-system/dist/components/display/Tooltip';
import { Animation } from '@zapier/design-system/dist/theme';
import { useIntersect, } from '@zapier/design-system/dist/hooks';
import { isolateComponent, labelStyles, withModifier, } from '@zapier/common-utils';
const contentNodeClassName = createUniqueClassName(__filename, 'content');
const contentNodeSelector = `.${contentNodeClassName}`;
const Styles = labelStyles(__filename, {
    root: (props) => [
        {
            position: 'relative',
            display: 'inline-block',
            [contentNodeSelector]: {
                opacity: 0,
                pointerEvents: 'none',
                transition: `opacity ${Animation.transitionDuration} ease-in-out`,
            },
            [`&:hover ${contentNodeSelector}`]: {
                opacity: 1,
                pointerEvents: 'auto',
            },
            [`&:focus-within ${contentNodeSelector}`]: {
                opacity: 1,
                pointerEvents: 'auto',
            },
        },
        !props.showTooltipOnTouchDevices &&
            withModifier('hideTooltipOnTouchDevices', {
                '@media (hover: none)': {
                    [`${contentNodeSelector}[class]`]: {
                        opacity: 0,
                    },
                },
            }),
        props.isBlock &&
            withModifier('block', {
                display: 'block',
            }),
    ],
});
const correctPosition = (position, result) => {
    const { isTopIntersecting, isBottomIntersecting, isLeftIntersecting, isRightIntersecting, } = result;
    if (isBottomIntersecting && position.includes('south')) {
        return position.replace('south', 'north');
    }
    else if (isTopIntersecting && position.includes('north')) {
        return position.replace('north', 'south');
    }
    else if (isLeftIntersecting && position.includes('west')) {
        return position.replace('west', 'east');
    }
    else if (isRightIntersecting && position.includes('east')) {
        return position.replace('east', 'west');
    }
    return position;
};
const defaultProps = {
    position: 'south',
    shouldCorrectPosition: true,
    showTooltipOnTouchDevices: true,
    tooltipAriaHidden: true,
};
export const TooltipWrapper = (props) => {
    const { children, content, position } = Object.assign(Object.assign({}, defaultProps), props);
    const [tooltipId] = useState(uniqueId('tooltip-'));
    const shouldRenderTooltip = !!content;
    const childProps = {
        ariaDescribedBy: shouldRenderTooltip ? tooltipId : undefined,
    };
    const threshold = 0.9;
    const rootMargin = `-25px`;
    const [setNode, result] = useIntersect({
        threshold,
        rootMargin,
    });
    const correctedPosition = isEmpty(result)
        ? position
        : correctPosition(position, result);
    return (isolateComponent("div", { css: Styles.root(props), ref: setNode },
        children({
            childProps,
            tooltipId,
        }),
        shouldRenderTooltip && (isolateComponent("div", { className: contentNodeClassName },
            isolateComponent(Tooltip, { allowMultiline: props.allowMultilineTooltip, ariaHidden: props.tooltipAriaHidden, id: tooltipId, isInteractive: props.isTooltipInteractive, position: props.shouldCorrectPosition ? correctedPosition : position }, content)))));
};
TooltipWrapper.defaultProps = {
    position: 'south',
    shouldCorrectPosition: true,
    showTooltipOnTouchDevices: true,
    tooltipAriaHidden: true,
};
//# sourceMappingURL=TooltipWrapper.js.map
